import { createReducer, on } from '@ngrx/store';
import { setLoading, storeUserDetail } from '../actions/user.actions';
import { User } from '@iris-sites/interfaces/sites.interfaces';

export const featureKey = 'user';

export interface UserState {
  currentUser?: User;
  profileComplete?: boolean;
  loading?: boolean;
}

export const initialState: UserState = {
  currentUser: undefined,
  loading: false,
};

export const userReducer = createReducer(
  initialState,
  on(storeUserDetail, (state, { user }) => ({
    ...state,
    currentUser: user,
    loading: false,
  })),
  on(setLoading, (state, { loading }) => ({
    ...state,
    loading,
  })),
);
